import React from 'react';

import styled from 'styled-components';

import { ResourceClickDecision, resourceClickLinkProps } from './resourceClickBehavior';

const NativeLink = styled.a`
  position: absolute;
  inset: 0;
  z-index: 3;
  border-radius: inherit;

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
`;

export const ResourceClickButton = styled.button`
  position: absolute;
  inset: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  border-radius: inherit;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }
`;

interface ResourceClickTargetProps {
  decision: ResourceClickDecision;
  label: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function ResourceClickTarget({
  decision,
  label,
  onClick,
}: ResourceClickTargetProps) {
  return <NativeLink {...resourceClickLinkProps(decision)} aria-label={label} onClick={onClick} />;
}
